import Swiper, { Navigation, Pagination, A11y } from 'swiper';

export default () => {
	// results slider
	const resultsWidget = document.querySelector(
		'#results-slider__sidebar.grid-results'
	);
	const resultsSwiper = new Swiper(resultsWidget, {
		modules: [Navigation, Pagination, A11y],
		navigation: {
			nextEl: resultsWidget.querySelector('.arrow-next'),
			prevEl: resultsWidget.querySelector('.arrow-prev'),
		},
		pagination: {
			el: resultsWidget.querySelector('.swiper-pagination'),
			type: 'bullets',
			clickable: true,
		},
		a11y: true,
		keyboardControl: true,
		grabCursor: true,
		watchOverflow: true,
		loop: true,
		autoHeight: true,
	});
};
